import logo from './logo.svg';
import './App.css';
//import libs queries
import { runConversation } from './libs/queries';
import React, { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
//load logo2.png
import logo2 from './images/logo5.png';

//const test = runConversation();

function App() {

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [customReason, setCustomReason] = useState('');
  const [privacyChecked, setPrivacyChecked] = useState(false);
  const [identityTheftChecked, setIdentityTheftChecked] = useState(false);
  const [confusingChecked, setConfusingChecked] = useState(false);
  const [tooSuddenChecked, setTooSuddenChecked] = useState(false);
  const [impactAbroadChecked, setImpactAbroadChecked] = useState(false);
  const [poorlyDefinedTermsChecked, setPoorlyDefinedTermsChecked] = useState(false);
  const [impactOnSmallBusinessChecked, setImpactOnSmallBusinessChecked] = useState(false);
  const [burdenOfSmallPurchases, setBurdenOfSmallPurchase] = useState(false);
  const [customChecked, setCustomChecked] = useState(false);
  const [letterContent, setLetterContent] = useState("");
  const [tone, setTone] = useState('');
  const [isLoading, setIsLoading] = useState(false); // Loading state
  const [isGenerated, setIsGenerated] = useState(false); // Loading state
  const [sliderValue, setSliderValue] = useState(50); // Initial value
  const [includeHeader, setIncludeHeader] = useState(false); // Initial value

  const handleSliderChange = (event) => {
      setSliderValue(event.target.value);
  };

  let description = '';
  let color = 'black';
  if (sliderValue >= 100) {
    description = 'Over-the-top [Not Recommended]';
    color = 'dark red';
  } else if (sliderValue >= 80) {
      description = '~Spicy!';
      color = 'red';
  } else if (sliderValue >= 50) {
      description = 'Medium Variance';
      color = 'orange';
  } else {
      description = 'Low Variance';
      color = 'green';
  }

  const handleReset = async () => {
    setName('');
    setEmail('');
    setPrivacyChecked(false);
    setIdentityTheftChecked(false);
    setConfusingChecked(false);
    setTooSuddenChecked(false);
    setImpactAbroadChecked(false);
    setPoorlyDefinedTermsChecked(false);
    setLetterContent('');
    setIsLoading(false);
    setIsGenerated(false);
    setCustomChecked(false);
    setCustomReason('');
    setTone('');
    setSliderValue(50);
    setIncludeHeader(false);
    setImpactOnSmallBusinessChecked(false);
    setBurdenOfSmallPurchase(false);
  }

  const handleCopyLetterTextToClipboard = async () => {
    navigator.clipboard.writeText(letterContent);
    //show a toast 
    toast.success('Copied Letter to clipboard!', {
      position: 'bottom-center',
      autoClose: 3000, // Close after 3 seconds
    });
  }

  const handleToneChange = (event) => {
    setTone(event.target.value);
    //console.log("Selected Emotion: ", event.target.value);
};

  const handleShareToTwitterClicked = async () => {
    //open twitter window and prompt to share this site
    window.open('https://twitter.com/intent/tweet?text=Let AI Assist in Drafting a Comment to the US Treasury Department on the Proposed Crypto Broker Reporting Regulations. https://treasuryraid.lexpunk.army/');

  }

  const handlelexPunkClicked = async () => {
    //open twitter window and prompt to share this site
    window.open('https://twitter.com/LeXpunK_Army');

  }

  const handleCallToAction = async () => {
    await navigator.clipboard.writeText(letterContent);
    toast.success('Copied Letter to clipboard!', {
      position: 'bottom-center',
      autoClose: 3000, // Close after 3 seconds
    });
    var newWindow = window.open('_blank', 'noopener,noreferrer');
    
    // Ensure the new window was successfully opened
    if (newWindow) {
        newWindow.opener = null;
        
        // If you want to ensure no referrer is sent, you can use the following line
        // However, note that this will cause the new page to be loaded in two steps
        newWindow.location = 'about:blank';
        newWindow.location.replace('https://www.regulations.gov/commenton/IRS-2023-0041-0001');
    }
  //  window.open('https://www.regulations.gov/commenton/IRS-2023-0041-0001');
  }

  const handleEmailClick = async () => {
    window.open(`mailto:${email}?subject=Letter to the IRS&body=${letterContent}`);
  }

  const handleButtonClick = async () => {
    const concerns = [];
    const concernsString = [];
    if (privacyChecked) concerns.push('Privacy');
    if (identityTheftChecked) concerns.push('Identity Theft');
    if (confusingChecked) concerns.push('Confusing');
    if (tooSuddenChecked) concerns.push('Too Sudden');
    if (impactAbroadChecked) concerns.push('Impact Abroad');
    if (poorlyDefinedTermsChecked) concerns.push('Poorly Defined Terms');
    if (impactOnSmallBusinessChecked) concerns.push('Impact on Small Businesses');
    if (burdenOfSmallPurchases) concerns.push('Burden of Small Purchases');

    concerns.forEach(option => {
      switch (option) {
       
       
      
        case 'Too Sudden':
          concernsString.push('Too quick. These proposed regs will come into effect before companies and protocols are able to accommodate them. ');
          break;
        case 'Impact Abroad':
          concernsString.push('Impact Abroad. The proposed regs do not sufficiently limit reporting requirements for protocols run outside the US, and for users outside the US. ');
          break;
        case 'Impact on Small Businesses':
          concernsString.push('Impact on small businesses: these reporting requirements will require small businesses and start up protocols who would not otherwise be required to track personal identifiable information to implement such tracking, which will cause expense to such businesses. These additional costs will put these projects at a disadvantage and could stifle innovation. ');
          break;
          case 'Poorly Defined Terms':
            concernsString.push('Poorly defined terms. The proposed regs use undefined terms, like platform, software and ledger, that are susceptible to many interpretations, and its definition of other terms, like wallet and validator, are defined in ways that do not describe their technical meaning. This will lead to confusion. ');
            break;
        case 'Burden for Small Purchases':
          concernsString.push('Burden for small purchases: These reporting requirements will require 1099s to be issued to persons who use digital assets to purchase small consumer goods or services, such as a buying a cup of coffee or paying a handyman. This will have the effect of making these assets harder to use for regular people. ');
          break;
        case 'Privacy':
          concernsString.push('Privacy. Privacy and safety associated with allowing so many third parties to know my sensitive financial data and social security number. ');
          break;
        case 'Identity Theft':
          concernsString.push('Identity Theft. The proposed regs will force many participants in DeFi to collect user information. This will cause sensitive taxpayer information to be stored without proper safeguards, and will encourage the creation of honey pots for identity theft under the guise of tax reporting. ');
          break;
          case 'Confusing':
            concernsString.push('Confusing. The proposed regs create reporting requirements for too many different participants in DeFi. This will cause multiple, inconsistent, reports to be generated for the same transaction. ');
            break;
      // Add cases for other options as needed
        default:
          break;
      }
    });
    if(customChecked && customReason!='') concernsString.push('and ' + customReason);
    
    const concatenatedString = concernsString.join(' ');
  
    const letterData = {
      "name": name,
      "concerns": concatenatedString,
      "tone": tone,
      "sliderValue": sliderValue,
      "includeHeader": includeHeader
    };
    setIsLoading(true);
    try {
      const response = await runConversation(letterData);
      setLetterContent(response);
    } catch (error) {
      // Handle any errors if needed
    } finally {
      setIsLoading(false); // Set loading state to false after the API call
      setIsGenerated(true);
    } // Call the runConversation function with the data
  };
  
  return (
    
    <div className="container">
         <div class="image-container"> <img  onClick={handlelexPunkClicked}  src={logo2} alt="Description" /></div>
        {!isGenerated ? (
  <header className="header">Let AI Assist in Drafting a Comment to the US Treasury Department on the Proposed Crypto Broker Reporting Regulations.  <a href="https://www.govinfo.gov/content/pkg/FR-2023-08-29/pdf/2023-17565.pdf" target="_blank" rel="noopener noreferrer">(🔗)</a></header>
) : null}
        {isGenerated ? (
  <header className="header">Your AI Generated Letter is Complete!</header>
) : null}
{isGenerated ? (
  <div>
  <label><b>To Submit on Regulations.gov:</b> 
  <p className='list'>1. 🔗 Click on <a className='mini-btn' onClick={handleCallToAction}>Submit Your Comment 📝</a></p>
  <p className='list'>2. 📋 Paste your letter in the comment form.</p>
  <p className='list'>3. ✍️ Modify it to reflect your views.</p>
  <p className='list'>4. ✅ Submit the <a href="https://www.regulations.gov/commenton/IRS-2023-0041-0001" target="_blank" rel="noopener noreferrer">regulations.gov</a> form.</p>
  <p className='list'><b>Here is your Letter:</b> <a onClick={handleCopyLetterTextToClipboard} className='copy-btn'>Copy 📄</a></p>
</label></div>
) : null}
  {!isGenerated ? (
  <><div className="search-box">
          <input type="text" placeholder="Name" onChange={(e) => setName(e.target.value)} />
        </div><div className="options">
            <label>What are your main concerns about the recently proposed regulations?</label>
           
            <label className="dark-btn-cb"><input type="checkbox" onChange={() => setImpactOnSmallBusinessChecked(!impactOnSmallBusinessChecked)} /> Small Business Impact.</label>
            <label className="dark-btn-cb"><input type="checkbox" onChange={() => setBurdenOfSmallPurchase(!burdenOfSmallPurchases)} /> Reporting Small Purchases.</label>
            <label className="dark-btn-cb"><input type="checkbox" onChange={() => setPrivacyChecked(!privacyChecked)} /> Privacy.</label>
            <label className="dark-btn-cb"><input type="checkbox" onChange={() => setIdentityTheftChecked(!identityTheftChecked)} /> Identity Theft.</label>
            <label className="dark-btn-cb"><input type="checkbox" onChange={() => setConfusingChecked(!confusingChecked)} /> Confusing.</label>
            <label className="dark-btn-cb"><input type="checkbox" onChange={() => setTooSuddenChecked(!tooSuddenChecked)} /> Too Sudden.</label>
            <label className="dark-btn-cb"><input type="checkbox" onChange={() => setImpactAbroadChecked(!impactAbroadChecked)} /> Impact Abroad.</label>
            <label className="dark-btn-cb"><input type="checkbox" onChange={() => setPoorlyDefinedTermsChecked(!poorlyDefinedTermsChecked)} /> Poorly Defined Terms.</label>
            <label className="dark-btn-cb"><input type="checkbox" onChange={() => setCustomChecked(!customChecked)} /> Enter my own concern.</label>
            {customChecked ? (<div className="search-box"><input type="text" placeholder="Enter your concern here" onChange={(e) => setCustomReason(e.target.value)} /></div>) : null }
            <label className="dark-btn-cb"><input type="checkbox" onChange={() => setIncludeHeader(!includeHeader)} /> Include a Letter Header.</label>
            <div>
            What tone would you like your letter to have? <div>
            <select className="dark-btn-cb" id="tone" value={tone} onChange={handleToneChange}>
                <option value="" disabled>Select a tone</option>
                <option value="neutral">Default</option>
                <option value="pessimistic">Pessimistic</option>
                <option value="passionate">Passionate</option>
                <option value="empathetic">Empathetic</option>
                <option value="concise">Concise</option>
                <option value="angry">Angry</option>
                <option value="encouraging">Encouraging</option>
                <option value="inquisitive">Inquisitive</option>
                <option value="patriotic">Patriotic</option>
                <option value="assertive">Assertive</option>
                <option value="diplomatic">Diplomatic</option>
            </select></div>
    <div> <div>
                Tone Level
            </div>
      <input style={{margin:"10px"}}
                type="range" 
                min="0" 
                max="100" 
                value={sliderValue} 
                onChange={handleSliderChange}
                className="slider"
            />
            <p style={{color: color}}>
                Value: {sliderValue} ({description})
            </p></div>
        </div>

          </div><button className="explore-btn" onClick={handleButtonClick} disabled={isLoading}>
            {isLoading ? 'Generating... (This may take a few minutes)' : 'Generate Letter'}
          </button></>) : null} 
  {isGenerated ? (
    <div class="letter">
       <pre>{letterContent}</pre>
</div>
) : null}
{isGenerated ? (
  <div><label><b>Remember:</b> Please review and ensure you agree with the letter before submitting.</label>
</div>
) : null}
{isGenerated ? ( 
  <div>
 <button className="dark-btn-lg" onClick={handleCallToAction}>Submit Your Comment 📝</button>
<div className="horizontal-buttons">
        <button className="dark-btn-btm" onClick={handleCopyLetterTextToClipboard}>Copy to Clipboard 📄</button>
       
        <button className="dark-btn-btm" onClick={handleReset}>Start Over 🔄</button>
      </div></div>) : null}
      
        {/* Footer */}
        <ToastContainer />
        <footer className="footer">
        Created by <a href="https://twitter.com/PrePopAi" target="_blank" rel="noopener noreferrer">0xPrepop</a> | 
        Analysis by <a href="https://twitter.com/LeXpunK_Army" target="_blank" rel="noopener noreferrer">LeXpunK</a> | 
         {/* Share on Twitter button */}
      <button className="twitter-button" onClick={handleShareToTwitterClicked}>
        Share on Twitter
      </button>
      </footer>
</div>
  );
}

export default App;
